import Vue from "vue";
import * as Sentry from "@sentry/vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTimeago from "vue-timeago";
import "./registerServiceWorker";
import moment from "moment";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import LoaderModel from "./components/loader/index";
import AlertModel from "./components/alert";
import ConfirmModel from "./components/confirm/index";
import VuetifyMask from "vuetify-mask";
import commonMixin from "./assets/js/common.mixin";
import "vue2-timepicker/dist/VueTimepicker.css";
import { errorLogsWrapper } from "./assets/js/errorLogsWrapper";
import { auth } from "./assets/js/firebase";

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyC_jMlA0Uia-d0wgSaEhqN_VuIJ8TzhhpE",
  installComponents: true,
  vueGoogleMapsCompatibility: false
});
global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;



Vue.use(ConfirmModel);
Vue.use(VuetifyMask);
Vue.use(AlertModel);
Vue.use(LoaderModel);

Vue.mixin(commonMixin);

Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "en" // Default locale
});
Vue.config.productionTip = false;


  Sentry.init({
    Vue,
    dsn: "https://369845a28b09bea58086bac16f04fe7c@o4512100981342208.ingest.us.sentry.io/4512100992417792",
    environment: "production",
    integrations: [new Sentry.BrowserTracing(), Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0 ,
    tracesSampleRate: 0.2
  });

const logGlobalError = (module, description, error) => {
  errorLogsWrapper({
    module,
    description,
    errorDetails: {
      message: error?.message || String(error),
      stack: error?.stack || null
    },
    createdBy: auth.currentUser?.email || "-"
  });
  Sentry.captureException(error, { tags: { module }, extra: { description } });
};

Vue.config.errorHandler = function (err, vm, info) {
  const componentName = vm?.$options?.name || vm?.$options?._componentTag || "unknown-component";
  console.error("[Global Vue Error]", err, "\ncomponent:", componentName, "\ninfo:", info);
  logGlobalError(componentName, `Vue error (${info})`, err);
};

window.addEventListener("unhandledrejection", function (event) {
  console.error("[Unhandled Promise Rejection]", event.reason);
  logGlobalError("unhandled-promise-rejection", "Unhandled promise rejection", event.reason);
});

window.addEventListener("error", function (event) {
  console.error("[Global JS Error]", event.error || event.message);
  logGlobalError("window-error", "Uncaught global JS error", event.error || event.message);
});

new Vue({
  router,
  store,
  vuetify,
  data() {
    return {
      isMobile: window.innerWidth < 768,
      loader: false,
      alertDialog: false,
      alertMessage: "Hello",
      alertTitle: "Alert"
    };
  },
  computed: {
    ele() {
      return this.isMobile ? "0" : "1";
    },
    dense() {
      // return this.isMobile ? true : false;
      return true;
    }
  },
  methods: {
    timeago(tz) {
      var t = moment(tz).startOf("day");
      var today = moment().startOf("day");
      var diff = today.diff(t, "days");
      if (diff === 0) return moment(tz).format("hh:mm a");
      if (diff <= 6) return moment(tz).format("ddd");
      if (diff > 6) return moment(tz).format("MM/DD/YYYY");
      return tz;
    },
    alert(msg) {
      const vm = this;
      vm.alertDialog = true;
      vm.alertMessage = msg;
      vm.alertTitle = "Message";
    }
  },
  render: h => h(App)
}).$mount("#app");


export const EventBus = new Vue();
